<ul class="fx-menu">
  <li>
    <a
      routerLink="/posts"
      routerLinkActive="fx-menu__link--active"
      [routerLinkActiveOptions]="{ exact: true }"
      >Posts</a
    >
  </li>
  <li>
    <a
      routerLink="/admin/posts"
      routerLinkActive="fx-menu__link--active"
      >Admin posts</a
    >
  </li>
  <li>
    <a
      routerLink="/home"
      routerLinkActive="fx-menu__link--active"
      >Home</a
    >
  </li>
  <li class="fx-menu__wrap-level-2">
    <a
      routerLink="/form"
      routerLinkActive="fx-menu__link--active"
      >Forms</a
    >
    <ul class="fx-menu__level-2">
      <li>
        <a
          routerLink="/form/form-template"
          routerLinkActive="fx-menu__link--active"
          >Form Template</a
        >
      </li>
      <li>
        <a
          routerLink="/form/form-reactive"
          routerLinkActive="fx-menu__link--active"
          >Form Reactive</a
        >
      </li>
      <li>
        <a
          routerLink="/form/form-reactive-add-remove"
          routerLinkActive="fx-menu__link--active"
          >Form Reactive (add/remove form rows)</a
        >
      </li>
    </ul>
  </li>
  <li>
    <a
      routerLink="/directives"
      routerLinkActive="fx-menu__link--active"
      >Directives</a
    >
  </li>
  <li>
    <a
      routerLink="/observables"
      routerLinkActive="fx-menu__link--active"
      >Observables</a
    >
  </li>
  <li>
    <a
      routerLink="/subjects"
      routerLinkActive="fx-menu__link--active"
      >Subjects</a
    >
  </li>
  <li>
    <a
      routerLink="/pipes"
      routerLinkActive="fx-menu__link--active"
      >Pipes</a
    >
  </li>
  <li>
    <a
      routerLink="/viewer"
      routerLinkActive="fx-menu__link--active"
      >Viewer</a
    >
  </li>
  <li>
    <a
      routerLink="/todos"
      routerLinkActive="fx-menu__link--active"
      >Todos</a
    >
  </li>
  <li>
    <a
      routerLink="/http"
      routerLinkActive="fx-menu__link--active"
      >HTTP</a
    >
  </li>
  <li>
    <a
      routerLink="/animation"
      routerLinkActive="fx-menu__link--active"
      >Animation</a
    >
  </li>
  <li>
    <a
      routerLink="/page/long-polling"
      routerLinkActive="fx-menu__link--active"
      >Long Polling</a
    >
  </li>
  <li>
    <a
      routerLink="/style-guide"
      routerLinkActive="fx-menu__link--active"
      >Style guide</a
    >
  </li>
</ul>
